import type { EscalateTo } from '../types/hatmail';

export interface EscalationTarget {
  label: string;
  recipients: string[];
}

/**
 * Internal escalate mailboxes. shipping@ and production@ were removed for the
 * HATmail launch. VIP Events / Charitable Giving goes to assist@.
 */
export const ESCALATION_TARGETS: Record<EscalateTo, EscalationTarget> = {
  marketing: {
    label: 'Marketing',
    recipients: ['marketing@greeleyhatworks.com'],
  },
  gm: {
    label: 'GM',
    recipients: ['sam@greeleyhatworks.com'],
  },
  foh_manager: {
    label: 'FOH Manager',
    recipients: ['info@greeleyhatworks.com'],
  },
  recraft: {
    label: 'ReCraft',
    recipients: ['recraft@greeleyhatworks.com'],
  },
  assist: {
    label: 'VIP Events / Charitable Giving',
    recipients: ['assist@greeleyhatworks.com'],
  },
};

export const ESCALATION_TARGET_ORDER: EscalateTo[] = [
  'marketing',
  'gm',
  'foh_manager',
  'recraft',
  'assist',
];

export function isEscalationTarget(value: string): value is EscalateTo {
  return Object.prototype.hasOwnProperty.call(ESCALATION_TARGETS, value);
}
